import * as Models from "../../../Models";

export interface ICreateUserRequest {
  email: string;
  password: string;
  password2: string;
  randomizePassword: boolean;
  firstName: string;
  lastName: string;
  enabled: boolean;
  userId: number;
  userName: string;
  windowsUserName: string;
  agentCode: string;
  solicitorNumber: string;
  suspendWorkIssueNotification: boolean;
  partner: Models.PartnerModel.IPartnerModel;
  groups: Array<Models.GroupModel.IGroupModel>;
}

export class CreateUserRequest implements ICreateUserRequest {
  email: string;
  password: string;
  password2: string;
  randomizePassword: boolean;
  firstName: string;
  lastName: string;
  enabled: boolean;
  userId: number;
  userName: string;
  windowsUserName: string;
  agentCode: string;
  solicitorNumber: string;
  suspendWorkIssueNotification = false;
  partner: Models.PartnerModel.PartnerModel;
  groups: Array<Models.GroupModel.GroupModel>;
}
